<template lang="pug">
  b-container.h-100.d-flex.flex-column
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Secuencias
        small.text-secondary.d-none.d-md-block Las secuencias se ejecutan transcurrido el tiempo que programes, una vez que el usuario llegue al bloque indicado.
      b-col(cols="auto")
        b-button.mr-2(variant="primary", @click="createSequence", :disabled="loading || busy") Crear secuencia
    b-row.h-100.overflow-y
      b-col.h-100.overflow-md-y.scrollable-area.br-1.p-0(md="3")
        b-overlay(:show="busy", variant="transparent", spinner-variant="primary")
          empty-message(v-if="!sequences.length && !busy", message="No hay secuencias creadas")
          b-card(v-if="sequences.length")
            b-nav(vertical, tabs)
              b-nav-item.mb-3(v-for="sequence in sequences", :key="sequence.sequence_id",  link-classes="account-link", :to="{name: 'Sequence', params: { sequence_id: sequence.sequence_id } }")
                .d-flex.align-items-center.justify-content-between(v-b-tooltip.hover="sequence.for_cases ? 'Secuencia para casos' : ''")
                  div {{sequence.name}}
                  inbox-icon.icon-sm.text-secondary(v-if="sequence.for_cases")
        //b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getObjectives')", v-if="!v_paginationShow")
            //b-card
              b-form-group(label="Objetivo", label-size="sm")
                b-form-input.bg-white(placeholder="Nombre del Objetivo", v-model="objective.name" )
      b-col.h-100.overflow-y.scrollable-area(v-if="$breakpoint.lgUp")
        empty-message(v-if="!$route.params.sequence_id  && !busy", :message="sequences.length ? 'Selecciona una secuencia' : 'No hay secuencias creadas'")
        b-overlay(:show="busy", variant="transparent", spinner-variant="primary")
          router-view(:key="$route.path")
    SideModal(v-model="side_modal", size="lg", @input="$router.push({name: 'Sequences'}).then(() => {})")
      router-view
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const sequenceController = createNamespacedHelpers('sequence')

export default {
  data () {
    return {
      loading: false,
      busy: false,
      side_modal: false,
    }
  },
  computed: {
    ...sequenceController.mapState({
      sequences: state => state.sequences
    })
  },
  methods: {
    ...mapActions(['sequence/all', 'sequence/create']),
    getSequences () {
      let self = this
      this.busy = true

      this['sequence/all']({
        account_id: self.$route.params.account_id,
        //...self.paginationParamsObject,
        callback: res => {
          self.busy = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            //self.parsePaginationDataFromResponse(res)
            if(self.sequences.length && !self.$route.params.sequence_id) {
              self.$router.push({name: 'Sequence', params: { sequence_id: self.sequences[0].sequence_id } }).catch(()=>{});
            }
          }
        }
      })
    },
    createSequence () {
      let self = this
      this.loading = true

      this['sequence/create']({
        account_id: self.$route.params.account_id,
        name: 'Nueva secuencia',
        enabled: true,
        callback: res => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$router.push({name: "Sequence", params: {sequence_id: res.resource.sequence_id}}).catch(()=>{});
          }
        }
      })
    },
  },
  mounted () {
    this.getSequences()
  },
  watch: {
    '$breakpoint' (value) {
      if (value.lgUp) {
        this.side_modal = false
      }

      if (value.mdDown && this.$route.name === 'Sequence' && this.$route.params.sequence_id) {
        this.side_modal = true
      }
    },
    '$route' (value) {
      this.side_modal = value.name === 'Sequence' && value.params.sequence_id && this.$breakpoint.mdDown;
    },
  }
}
</script>

<style lang="scss" scoped>
.account-link {
  border-radius: 5px;

  &:hover, &.router-link-exact-active {
    background: rgba(14, 92, 207, 0.1) !important;
  }
}
</style>
